import React from 'react'
import css from './style.css'

const Label = (props) => (
  <div className={css.label}>
    {props.children}
  </div>
)

export default Label



// WEBPACK FOOTER //
// ./src/components/label/index.js